import { Component, OnInit, inject } from '@angular/core';
import { Observable, delay, map } from 'rxjs';
import { LoadDynamicComponentService } from '../../services/load-dynamic-component.service';
import { LoaderService } from '@services/loader.service';
import { EnumeratorsService } from '@services/http/enumerators.service';
import { UserProfile, UserService } from 'app/services/user.service';
import { AuthService } from '@services/http/auth.service';
import { PolicyService } from '@services/http/policies.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  private _authService: AuthService = inject(AuthService);
  private _userService: UserService = inject(UserService);
  private _policiesService: PolicyService = inject(PolicyService);
  private _enumService: EnumeratorsService = inject(EnumeratorsService);
  _loadComponentService: LoadDynamicComponentService = inject(LoadDynamicComponentService);
  _loaderService: LoaderService = inject(LoaderService);

  isRightOpen$: Observable<boolean> = this._loadComponentService.isRightOpen$;
  profileInfo$: Observable<UserProfile>;
  spiner$: Observable<boolean> = this._loaderService.loaderSubject.pipe(delay(0));
  userPhoto = 'assets/images/user-no-photo.png';

  ngOnInit(): void {
    this._enumService.getAllEnumerators().subscribe();
    this.profileInfo$ = this._userService.userSubject.pipe(
      map(user => {
        if (user) {
          user.profileImage =
            user?.profileImage === '5197ef8c-d06a-4fd1-bd27-303df51a6e39.jpg' ? this.userPhoto : user.profileImage;
          return user;
        }
      })
    );
  }

  logout() {
    this._policiesService.policiesSubject.next([]);
    this._authService.logout();
  }

  toggleRightSidebar(state: boolean) {
    this._loadComponentService.toggleRightSidebar(state);
  }
}
